<template>
    <div class="report-indicator-light-mini"
         v-if="participantScores && (litUp || showAlways)">

        <div class="report-indicator-light-mini--light" :class="{'report-indicator-light-mini--lit-up': litUp}">
            <shs-icon name="bell" class="mr-2 report-indicator-light-mini__icon"></shs-icon><span
                class="report-indicator-light-mini__text">{{
            $i18n.gt(labelKey) }}</span>
        </div>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

/**
 * Displays a color-coded indicator light based on the value of a given score
 */
export default Vue.extend({
    props: {
        scoreName: String,
        labelKey: String,
        showAlways: Boolean
    },
    computed: {
        survey() {
            return this.$store.state.survey
        },
        participantScores() {
            return this.$store.state.patientParticipant.latestScoreDefs
        },
        scoreDef() {
            return this.$store.state.patientParticipant.latestScoreDefs[this.scoreName]
        },
        level() {
            return this.scoreDef ? this.scoreDef.score.score : null
        },
        litUp() {
            return this.level == 1
        }
    }
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
.report-indicator-light-mini {
    //display: inline-block;
    //width: auto;
    border-radius: 4px;
    text-align:center;
}

.report-indicator-light-mini--light {
    padding:4px 12px;
    border:solid 2px #ddd;
    background-color: #eee;
    border-radius: 4px;
}

.report-indicator-light-mini__icon {
    display:none;
    use {fill:#5E4D00;}
}

.report-indicator-light-mini--lit-up {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffe052; // make this same as GAUGE_COLORS.yellow
    border-color:#FFD001;
    border-radius:4px;
    color:#5E4D00;
    box-shadow:0 0 20px rgba(255,208,1,.8);
    .report-indicator-light-mini__icon {
        display:inline-block;
    }
}


</style>
